module.exports = __webpack_public_path__ + "img/02.3d9e0356.jpg";